import script from "./Terms.vue?vue&type=script&setup=true&lang=js"
export * from "./Terms.vue?vue&type=script&setup=true&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=bee38a2c&scoped=true&lang=css"
script.__scopeId = "data-v-bee38a2c"

export default script